import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsSchemasRoute: InvariantJiraRoute = {
	name: 'assets',
	path: '/jira/assets/schemas',
	exact: true,
};
